export enum PayRoute {
  Payin = 'payin',
  Payout = 'payout',
}
